<template>
  <AttrSelect
    v-if="options.length"
    label="格式"
    :value="isText ? stringItem?.sourceFormat : shape.attrs.sourceFormat"
    :options="options"
    :disabled="!!disabled"
    :width="180"
    @change="onChange"
  />

  <!-- 数据源单位 -->
  <template v-if="needUploadUnitImg">
    <template
      v-for="(unitLable, index) in shape.sourceItems.map(
        (item) => item?.unit
      ) ?? []"
      :key="unitLable"
    >
      <AttrImage
        :label="`单位（可选）：${unitLable}`"
        :base64="getUnitValue(getUnitName(index))"
        @change="(imagePath: string) => onUnitUpload(getUnitName(index), imagePath)"
        @delete="() => onUnitDelete(getUnitName(index))"
      />
    </template>
  </template>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { useDataSource } from '@/hooks';
import { PropType } from 'vue';
import { DataSourceFormat } from '@/resources/enum';
import { Shape, ShapeType } from '@/services/shape';
import { useEditorStore } from '@/store/use-editor-store';
import { ResourceKey } from '@/services/shape/attributes';

const editorStore = useEditorStore();

const props = defineProps({
  shape: {
    type: Object as PropType<Shape>,
    required: true
  },
  stringIndex: {
    type: Number,
    default: undefined
  },
  disabled: {
    type: Boolean,
    default: false
  }
});

const { getFormatOptions } = useDataSource();

const isText = computed(() => props.shape.type == ShapeType.Text);
const stringItem = computed(() =>
  isText.value
    ? props.shape.attrs.strings?.[props.stringIndex ?? -1]
    : undefined
);

const options = computed(() => {
  const source = isText.value
    ? stringItem.value?.value
    : props.shape.attrs.source;
  return getFormatOptions(source ?? '', props.shape.type);
});

const onChange = (val: DataSourceFormat) => {
  const shape = props.shape;
  if (isText.value) {
    const strings = shape.attrs.strings;
    const stringItem = strings?.[props.stringIndex ?? -1];
    if (stringItem) {
      stringItem.sourceFormat = val;
      shape.setAttrs({ strings: strings });
    }
  } else {
    shape.setAttrs({ sourceFormat: val });
  }
};

// 数据源单位
const needUploadUnitImg = computed(() => {
  const { type, attrs } = props.shape;
  return (
    type == ShapeType.ImageArray &&
    [
      DataSourceFormat.Format_8时,
      DataSourceFormat.Format_08时,
      DataSourceFormat.Format_SPF8,
      DataSourceFormat['Format_8.0时'],
      DataSourceFormat['Format_SPF8.0']
    ].includes(attrs.sourceFormat as 1)
  );
});

const getUnitName = (index: number): ResourceKey =>
  index ? 'unitIcon2' : 'unitIcon';

const getUnitValue = (resourceName: ResourceKey) => {
  return props.shape.getResources({
    resourceName,
    colorGroup: editorStore.themeColorId,
    base64: true
  })?.[0];
};

const onUnitUpload = (resourceName: ResourceKey, unitImgPath: string) => {
  props.shape?.uploadResource({
    resourceName,
    colorGroup: editorStore.themeColorId,
    realpath: unitImgPath
  });
};
const onUnitDelete = (resourceName: ResourceKey) => {
  props.shape?.deleteResource({
    resourceName,
    colorGroup: editorStore.themeColorId
  });
};
</script>
